import {getEventDelay} from "./get-event-delay";
import {throttle} from "./throttle";

export function heroSection() {
    let prefix = '.hero-section';
    let $section = $(prefix + ':first');
    let $sectionInner = $(prefix + '-inner');
    let $sectionText = $sectionInner.find(prefix + '-text');
    let $sectionBG = $section.find(prefix + '-bg');
    let alertBar = $('.alert-bar');
    let win = window;
    let $win = $(win);
    let api = win.api;

    if (api === undefined) {
        win.api = {};
        api = win.api;
    }

    api.updateHero = function () {
        let alertBarHeight = alertBar.length ? alertBar.outerHeight() : 0;
        let isLargeBreakpoint = win.innerWidth >= 768;
        let sectionTopPartHeight = (win.innerHeight - alertBarHeight);
        let sectionTopPartHeightPx = sectionTopPartHeight + 'px';
        let sectionTextHeight = isLargeBreakpoint ? 'auto' : sectionTopPartHeightPx;

        $sectionInner.css('height', sectionTopPartHeightPx);
        $sectionText.css('height', sectionTextHeight);
        $sectionBG.css({
            top: (-alertBarHeight) + 'px',
            height: (sectionTopPartHeight + alertBarHeight) + 'px'
        });
    }

    $win.on("load", function () {
        api.updateHero();

        ["resize", "orientationchange"].map(function (item) {
            let eventDelay = getEventDelay(item);
            $win.on(item, throttle(api.updateHero, eventDelay));
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/hero-section.js